module.exports = __webpack_public_path__ + "resources/img/sp_main.66827da3a240b88e9bfda589e1ce0ff9.png";